<template>
  <div class="page-container animate-fade-in-up">
    <PageHeader icon="el-icon-link" title="生成员工离职调研链接" subtitle="向员工发送匿名调研问卷，收集真实的离职原因反馈" />

    <div class="survey-cards">
      <!-- 调研参数 -->
      <div class="survey-card">
        <div class="survey-card-header">
          <div class="survey-card-icon" style="background: linear-gradient(135deg, #D1FAE5, #A7F3D0);">
            <i class="el-icon-link" style="color: #065F46;"></i>
          </div>
          <h3 class="survey-card-title">调研参数</h3>
        </div>
        <div class="survey-card-body">
          <div class="survey-field" style="margin-bottom: 0;">
            <div class="field-label">链接有效期（天）</div>
            <el-input-number v-model="expireDays" :min="1" :max="30" />
          </div>
        </div>
      </div>

      <!-- 话术配置 -->
      <div class="survey-card">
        <div class="survey-card-header">
          <div class="survey-card-icon" style="background: linear-gradient(135deg, #F5D76E, #F2C94C);">
            <i class="el-icon-chat-dot-round" style="color: #1B3C59;"></i>
          </div>
          <h3 class="survey-card-title">话术配置</h3>
        </div>
        <div class="survey-card-body">
          <el-input
            type="textarea"
            v-model="template"
            :rows="8"
            maxlength="1000"
            show-word-limit
            class="survey-textarea"
          />
          <div class="survey-hint">
            <i class="el-icon-info"></i> 支持变量替换：{{employee_name}} 会自动替换为真实姓名
          </div>
        </div>
      </div>

      <!-- 发送对象选择 -->
      <div class="survey-card">
        <div class="survey-card-header">
          <div class="survey-card-icon" style="background: linear-gradient(135deg, #BFDBFE, #93C5FD);">
            <i class="el-icon-user" style="color: #1E40AF;"></i>
          </div>
          <h3 class="survey-card-title">发送对象选择</h3>
        </div>
        <div class="survey-card-body">
          <div class="survey-field">
            <div class="field-label">员工姓名</div>
            <el-select v-model="selectedEmployeeId" placeholder="请选择已离职员工" class="survey-select" clearable filterable>
              <el-option
                v-for="emp in resignedEmployees"
                :key="emp.employee_id"
                :label="emp.real_name + (emp.dept_name ? ' (' + emp.dept_name + ')' : '')"
                :value="emp.employee_id"
              />
            </el-select>
            <div class="survey-hint" style="margin-top: 8px;">
              <i class="el-icon-info"></i> 仅显示当前任务下的已离职员工
            </div>
          </div>
          <div class="survey-field">
            <div class="field-label">分发方式</div>
            <el-radio-group v-model="dispatchType">
              <el-radio :label="1">通过系统发送邮件 / 内部信</el-radio>
              <el-radio :label="2">仅生成并复制链接</el-radio>
            </el-radio-group>
          </div>
          <el-button
            type="primary"
            class="generate-btn btn-click"
            :disabled="!selectedEmployeeId || $store.getters.isCurrentTaskExpired"
            @click="generateLink"
          >
            <i class="el-icon-magic-stick"></i> 生成调研链接
          </el-button>
        </div>
      </div>
    </div>

    <div v-if="generatedUrl" class="result-card animate-fade-in-up">
      <div class="result-header">
        <i class="el-icon-success" style="color: var(--color-low);"></i>
        <span>链接已生成</span>
      </div>
      <div class="result-body">
        <div class="result-url">
          <input v-model="generatedUrl" readonly class="url-input" />
          <el-button @click="copyUrl" class="copy-btn">
            <i class="el-icon-document-copy"></i> 复制
          </el-button>
        </div>
        <div class="result-meta">
          <i class="el-icon-time"></i> 链接有效期至: {{ expireTime }} | 每个 Token 仅允许提交一次
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader.vue'

export default {
  name: 'SurveyCreate',
  components: { PageHeader },
  data() {
    return {
      selectedEmployeeId: null,
      dispatchType: 2,
      expireDays: 3,
      template: '您好 {{employee_name}}，感谢您抽出时间来做这个调研。因为您是我们的绩优员工，是为公司做出了贡献的，是得到过公司认可的，所以我们很重视您。现在您提出离职，换一个赛道，我们尊重您的选择，但依然觉得很不舍，很惋惜。我们想借这个机会，不仅是想深入了解一下您提出离职的主要原因，更希望您能和我们聊一些您对公司目前发展情况的看法，帮助我们改进。',
      generatedUrl: '',
      expireTime: ''
    }
  },
  computed: {
    resignedEmployees() {
      return this.$store.getters.taskResigned || []
    }
  },
  created() {
    const s = this.$store.state.settings.settings
    this.expireDays = (s && s.survey && s.survey.expireDays) || 3
  },
  methods: {
    async generateLink() {
      if (!this.selectedEmployeeId) {
        this.$message.warning('请选择已离职员工')
        return
      }
      try {
        const res = await this.$api.createSurvey({
          employee_id: this.selectedEmployeeId,
          content_template: this.template,
          expire_days: this.expireDays
        })
        if (res.data) {
          const emp = this.resignedEmployees.find(e => e.employee_id === this.selectedEmployeeId)
          this.generatedUrl = window.location.origin + '/#/survey/' + res.data.survey_token
          this.expireTime = res.data.expire_at
          this.$store.commit('ADD_SURVEY', {
            survey_id: Date.now(),
            token: res.data.survey_token,
            employee_id: this.selectedEmployeeId,
            employee_name: emp ? emp.real_name : '',
            link: this.generatedUrl,
            created_at: new Date().toISOString().replace('T', ' ').slice(0, 19),
            status: 'pending',
            task_id: (this.$store.state.tasks && this.$store.state.tasks.currentTask && this.$store.state.tasks.currentTask.task_id) || 1
          })
          this.$message.success('调研链接已生成')
        }
      } catch (e) {
        this.$message.error('生成失败：' + ((e.response && e.response.data && e.response.data.message) || e.message || '未知错误'))
      }
    },
    copyUrl() {
      const input = document.createElement('input')
      input.value = this.generatedUrl
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('链接已复制到剪贴板')
    }
  }
}
</script>

<style scoped>
.page-container {
  max-width: 900px;
  margin: 0 auto;
}
.survey-cards {
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
  margin-bottom: var(--space-2xl);
}

.survey-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.survey-card-header {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--color-border-light);
}

.survey-card-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.survey-card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.survey-card-body {
  padding: var(--space-xl);
}

.survey-textarea {
  margin-bottom: var(--space-sm);
}

.survey-hint {
  font-size: 13px;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.survey-field {
  margin-bottom: var(--space-lg);
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: var(--space-sm);
}

.survey-select {
  width: 100%;
}

.generate-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
}

.result-card {
  background: var(--color-surface);
  border: 1px solid var(--color-low);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.result-header {
  padding: var(--space-md) var(--space-xl);
  background: var(--color-low-bg);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-low-text);
}

.result-body {
  padding: var(--space-xl);
}

.result-url {
  display: flex;
  gap: var(--space-md);
  margin-bottom: var(--space-md);
}

.url-input {
  flex: 1;
  padding: 10px var(--space-lg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  color: var(--color-text);
  background: var(--color-bg);
  outline: none;
}

.result-meta {
  font-size: 13px;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}
</style>
